export default {
  modalName: {
    id: 'service_drawer_name',
    defaultMessage: 'Backup service',
  },
  warranty: {
    id: 'service_drawer_table_warranty',
    defaultMessage: 'Warranty',
  },
}
